module.exports = __webpack_public_path__ + "img/bg1.4de062fb.jpeg";